import { GCOLoader } from './gco-loader/GCOLoader';
import { NormalLoader } from './normal-loader/NormalLoader';
import { CircleLoader } from './circle-loader/CircleLoader';
import { CartLoaderType } from './types/enums';
import { CartLoaderProps } from './types/propsType';

export const CartLoader = ({ loaderType }: CartLoaderProps) => {
  switch (loaderType) {
    case CartLoaderType.NORMAL:
      return <NormalLoader />;
    case CartLoaderType.GCO:
      return <GCOLoader />;
    case CartLoaderType.PAGE_LOADER:
      return <CircleLoader />;
    default:
      return <></>;
  }
};

export { CartLoaderType };
